import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { integrationCustomFieldApi } from "api/TenantSlug/IntegrationCustomField/api";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - types from BE
import StoreIntegrationCustomFieldData = App.Http.Requests.Integration.StoreIntegrationCustomFieldData;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - types from BE
import UpdateIntegrationCustomFieldRequest = App.Http.Requests.Integration.UpdateIntegrationCustomFieldRequest;
import GetIntegrationCustomFieldResponse = App.Http.Responses.Integration.GetIntegrationCustomFieldResponse;
import GetIntegrationCustomFieldsResponse = App.Http.Responses.Integration.GetIntegrationCustomFieldsResponse;

// Query to get a list of custom fields for a specific integration
export const useGetIntegrationCustomFieldsQuery = (integrationId: string, options = {}) => {
    return useQueryApi<GetIntegrationCustomFieldsResponse>({
        queryKey: ["getIntegrationCustomFields", integrationId],
        queryFn: () => integrationCustomFieldApi.index(integrationId),
        ...options,
    });
};

// Query to get a specific custom field for a specific integration
export const useGetIntegrationCustomFieldQuery = (integrationId: string, customFieldId: string, options = {}) => {
    return useQueryApi<GetIntegrationCustomFieldResponse>({
        queryKey: ["getIntegrationCustomField", integrationId, customFieldId],
        queryFn: () => integrationCustomFieldApi.show(integrationId, customFieldId),
        ...options,
    });
};

// Mutation to store a new custom field for a specific integration
export const useStoreIntegrationCustomFieldMutation = (
    integrationId: string,
    options: UseMutationOptions<
        GetIntegrationCustomFieldResponse,
        AxiosError<ApiErrorResponse>,
        StoreIntegrationCustomFieldData
    > = {}
) => {
    return useMutationApi<GetIntegrationCustomFieldResponse, StoreIntegrationCustomFieldData>({
        mutationKey: ["storeIntegrationCustomField", integrationId],
        mutationFn: (request) => integrationCustomFieldApi.store(integrationId, request),
        ...options,
    });
};

// Mutation to update an existing custom field using PUT
export const useUpdateIntegrationCustomFieldMutation = (integrationId: string, customFieldId: string, options = {}) => {
    return useMutationApi<GetIntegrationCustomFieldResponse, UpdateIntegrationCustomFieldRequest>({
        mutationKey: ["updateIntegrationCustomField", integrationId, customFieldId],
        mutationFn: (request: UpdateIntegrationCustomFieldRequest) =>
            integrationCustomFieldApi.update(integrationId, customFieldId, request),
        ...options,
    });
};

// Mutation to destroy a custom field for a specific integration
export const useDestroyIntegrationCustomFieldMutation = (integrationId: string, options = {}) => {
    return useMutationApi<void, string>({
        mutationKey: ["destroyIntegrationCustomField", integrationId],
        mutationFn: (customFieldId: string) => integrationCustomFieldApi.destroy(integrationId, customFieldId),
        ...options,
    });
};
